const state = {
  lastAnnonceMatchAttemptId: null,
  currentUserCountryCode: 'FR',
}

const getters = {
  lastAnnonceMatchAttemptId: (state) => state.lastAnnonceMatchAttemptId,
  currentUserCountryCode: (state) => state.currentUserCountryCode,
}

const actions = {

  setLastAnnonceMatchAttemptId ({commit}, id) {
    commit('lastAnnonceMatchAttemptId', id)
  },

  setCurrentUserCountryCode ({commit}, countryCode) {
    commit('currentUserCountryCode', countryCode)
  },

}

const mutations = {

  setLastAnnonceMatchAttemptId (state, id) {
    state.lastAnnonceMatchAttemptId = id
  },

  setCurrentUserCountryCode (state, countryCode) {
    state.currentUserCountryCode = countryCode
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/storeUtils.js